import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.scss";
import TopNavBar from "./components/TopNavBar/TopNavBar";
import Home from "./views/Home/Home";
import Illustrations from "./views/Illustrations/Illustrations";
import ForKids from "./views/ForKids/ForKids";
import Contact from "./views/Contact/Contact";

const App = () => {
  return (
    <div className="App">
      <Router>
        <TopNavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ilustrace" element={<Illustrations />} />
          <Route path="/tvorba-pro-deti" element={<ForKids />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
